import api from '../BaseUrl';
import { Skills } from '../Client/PublicResponse';

export type { Skills };

export const getSkills = async (): Promise<Skills[]> => {
  const res = await api.get<Skills[]>('/api/Skill/GetSkill');
  return res.data;
};

export const postSkills = async (data: Omit<Skills, 'id'>): Promise<void> => {
  await api.post('/api/Admin/AddSkill', data);
};

export const putSkills = async (id: string | number, data: Omit<Skills, 'id'>): Promise<void> => {
  await api.put(`/api/Admin/UpdateSkill/${id}`, data);
};

export const deleteSkills = async (id: string | number): Promise<void> => {
  await api.delete(`/api/Admin/DeleteSkill/${id}`);
};
